export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9480.87fa9ad0.jpg";